var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AssessmentRiskRender } from 'constants/assessments';
import { Flex, Icon, Text, VBadge } from 'shared/components';
import { FlaggedContent } from 'src/flagging/components';
export var AssessmentRiskScore = function (_a) {
    var risk = _a.risk, score = _a.score, maxScore = _a.maxScore;
    var renderInfo = AssessmentRiskRender[risk];
    return (_jsx(Flex, __assign({ alignItems: "center" }, { children: _jsx(FlaggedContent, __assign({ flag: 'ENABLE_MEASURES_MBC_UPDATES', disabledContent: _jsxs(_Fragment, { children: [_jsx(Icon, { as: renderInfo.icon, color: renderInfo.iconColor, boxSize: 4, mr: 2 }), _jsxs(Text, __assign({ size: renderInfo.size, color: renderInfo.color }, { children: [score, "/", maxScore] }))] }) }, { children: _jsxs(_Fragment, { children: [_jsx(VBadge, __assign({ colorScheme: renderInfo.colorScheme, variant: renderInfo.emphasis }, { children: renderInfo.copy })), _jsxs(Text, __assign({ paddingLeft: 1, size: renderInfo.size, color: renderInfo.color }, { children: [score, "/", maxScore] }))] }) })) })));
};
